/* @flow */
import * as React from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import VirtualizedSelect from 'react-virtualized-select';

import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';

import { apiService } from 'services/ServiceRegistry';

import styles from 'forms/components/inputs/ElectroSelect/ElectroSelect.module.scss';

/**
 * ActionDrawerLocationSelect
 *
 * @prop {String} name
 * @prop {String} placeholder
 * @prop {String} type
 * @prop {String} url
 * @prop {Object} value
 * @prop {Function} onChange
 * @return {React.Node}
 */
class ActionDrawerLocationSelect extends React.Component<*> {
  @observable isFocused: boolean = false;

  @action toggleFocus = () => {
    this.isFocused = !this.isFocused;
  };

  @observable localState: Object = {
    loading: false,
    options: [],
  };

  async load(url: string): Promise<void> {
    this.localState.loading = true;
    this.localState.options = [];

    try {
      const data: * = await apiService.getResource(url);

      this.localState.options = this.props.type === 'country' ? data : data.active || [];
    } catch (err) {
      console.log(err);
    }

    this.localState.loading = false;
  }

  componentDidMount() {
    if (this.props.url) {
      this.load(this.props.url);
    }
  }

  // eslint-disable-next-line camelcase, id-length
  UNSAFE_componentWillReceiveProps(newProps: Object) {
    if (newProps.url && newProps.url !== this.props.url) {
      this.load(newProps.url);
    } else if (!newProps.url) {
      this.localState.options = [];
    }
  }

  render(): React.Node {
    const { field }: any = this.props;

    const isDisabled: boolean = this.localState.options.length === 0;
    const isRequired: boolean = Boolean(
      field.rules &&
        field.rules.includes('required') &&
        (this.props.name === 'company' ||
          this.props.name === 'country' ||
          this.props.name === 'site')
    );
    const isFocusedClass: string = this.isFocused ? styles['is-focused'] : '';
    const isErrorClass: string = field.value === '' && field.error ? styles['is-error'] : '';
    const isDisabledClass: string = isDisabled ? styles['is-disabled'] : '';

    return (
      <div
        className={`${
          styles['electro-select']
        } ${isFocusedClass} ${isErrorClass} ${isDisabledClass}`}
      >
        <FormControl disabled={isDisabled}>
          {
            <InputLabel
              className={styles['custom-placeholder']}
              required={isRequired}
              shrink={Boolean(this.props.value || this.isFocused)}
            >
              {this.props.placeholder ? this.props.placeholder : 'Select...'}
            </InputLabel>
          }
          <VirtualizedSelect
            arrowRenderer={() => (
              <svg className={styles['dropdown-icon']}>
                <use xlinkHref="#icon-drop-arrow-down" />
              </svg>
            )}
            className={styles['electro-select-field']}
            noResultsText="No results found"
            loadingPlaceholder=""
            onFocus={this.toggleFocus}
            onBlur={this.toggleFocus}
            inputProps={{
              autoComplete: 'off',
            }}
            optionHeight={({ option }) => (option.name.length > 50 ? 70 : 35)}
            placeholder={null}
            value={this.props.value}
            options={this.localState.options.length > 0 ? this.localState.options.slice() : []}
            disabled={isDisabled}
            onChange={(value: Object) => {
              this.props.onChange(value);
            }}
            isLoading={this.localState.loading}
            clearable={false}
            searchable={true}
            labelKey="name"
            valueKey="id"
          />
          {field.value === '' && field.error && (
            <FormHelperText error={true}>{field.error}</FormHelperText>
          )}
        </FormControl>
      </div>
    );
  }
}

export default observer(ActionDrawerLocationSelect);
